const navigationEs = {
  menu: {
    tiendas: 'Tiendas',
    clientes: 'Clientes',
    packaging: 'Packaging',
    warehouse_material: 'Material almacén',
    puestos_trabajo: 'Puestos de trabajo',
    productos: 'Productos',
    productos_main: 'Productos',
    productos_packs: 'Packs',
    crm: 'CRM',
    reportes: 'Reportes',
    rentabilidad_section: 'Rentabilidad',
    profitability_overview: 'Resumen',
    profitability_ad_spend: 'Gasto publicitario',
    profitability_product_costs: 'Costes de producto',
    profitability_shipping_costs: 'Costes de envío',
    productos_sin_stock: 'Productos sin stock',
    pedidos: 'Pedidos',
    pedidos_main: 'Pedidos',
    pedidos_preparar: 'Pedidos por preparar',
    pedidos_enviados: 'Pedidos enviados',
    billeteras: 'Billetera',
    retiros: 'Retiros',
    payment_files: 'Ficheros de pago',
    billeteras_main: 'Billeteras',
    cuentas_bancarias: 'Cuentas bancarias',
    recargas: 'Recargas',
    wallets_accounting_sync: 'Contabilidad Holded',
    ordenes_ubicacion: 'Órdenes de ubicación',
    preparar_pedidos: 'Preparación de pedidos',
    orders: 'Órdenes',
    preparaciones: 'Preparaciones',
    manifests: 'Manifiestos',
    packs: 'Packs',
    trabajos_extra: 'Trabajos extra',
    ubicaciones: 'Ubicaciones',
    carritos: 'Carritos',
    almacen: 'Almacén',
    almacen_configuracion: 'Configuración',
    almacen_grupo: 'Almacén',
    almacen_ordenes_ubicacion: 'Órdenes de ubicación',
    almacen_ubicaciones: 'Ubicaciones',
    almacen_carritos: 'Carritos',
    almacen_reubicar: 'Reubicar',
    lotes: 'Lotes',
    almacen_informes: 'Informes',
    ready_to_prepare_by_hour: 'Pedidos por hora',
    merchandise: 'Mercancías',
    receptions: 'Recepciones',
    entradas: 'Entradas',
    entradas_recepciones: 'Recepciones',
    entradas_trabajos_extra: 'Trabajos extra',
    entradas_rehusados: 'Rehusados',
    entradas_mercancias: 'Mercancías de clientes',
    movimientos: 'Movimientos',
    movimientos_stock: 'Stock',
    movimientos_ubicaciones: 'Ubicaciones',
    rehusados: 'Rehusados',
    incidencias: 'Incidencias',
    incidencias_main: 'Incidencias',
    mapeos: 'Mapeo Incidencias',
    configuracion: 'Configuración',
    backToApp: 'Volver a la app',
    configSectionAccount: 'Cuenta',
    configSectionTeam: 'Equipo',
    configSectionAdmin: 'Administración',
    empresa: 'Empresa',
    perfil: 'Perfil',
    suscripcion: 'Suscripción',
    logout: 'Cerrar sesión',
    workspace: 'Espacio de trabajo',
    printers: 'Impresoras',
    search_printer: 'Buscar impresora',
    general: 'General',
    impresoras: 'Impresoras',
    mensajerias: 'Mensajerías',
    rules: 'Reglas de envío',
    shippingRulePresets: 'Presets de Reglas de Envío',
    packagingRulesets: 'Reglas de packaging',
    coverageZones: 'Zonas de cobertura',
    shipmentStatusMapping: 'Estados Logísticos',
    courierErrorsMapping: 'Errores de courier',
    trackingMonitoring: 'Monitoreo de Tracking',
    productCategories: 'Categorías de producto',
    integrations: 'Integraciones',
    webhooks: 'Webhooks',
    'mi-perfil': 'Mi perfil',
    notificaciones: 'Notificaciones',
    inicio: 'Inicio',
    theme: 'Tema',
    themes: {
      light: 'Claro',
      dark: 'Oscuro',
      system: 'Sistema',
    },
    language: 'Idioma',
    languages: {
      es: 'Español',
      en: 'English',
    },
    titles: {
      stock_movements: 'Movimientos de stock',
      location_movements: 'Movimientos de ubicación',
      integrated_messaging: 'Mensajerías Integradas',
      rules: 'Reglas de envío',
      logistics: 'Logística',
      profitability: 'Rentabilidad',
      logistic_pivot: 'Métricas de logística',
      inventory: 'Inventario',
      marketing: 'Marketing',
    },
    afiliados: 'Afiliados',
    roles: 'Roles',
    users: 'Usuarios',
    centro_ayuda: 'Centro de ayuda',
    contabilidad: 'Contabilidad',
    facturacion: 'Facturación',
    facturacion_pedidos: 'Pedidos',
    facturacion_almacenamiento: 'Almacenamiento',
    facturacion_cuota_minima: 'Cuota mínima',
    facturacion_prefacturacion: 'Prefacturación',
    facturacion_facturas: 'Facturas',
    facturacion_facturas_courier: 'Facturas mensajería',
    facturacion_tarifas: 'Tarifas',
    orders_without_weight: 'Pedidos sin peso',
    three_pl_excel_reports: 'Exportación de informes',
    legacy_dashboard: 'Clientes legacy activos',
    reportes_contabilidad: 'Reportes',
    contabilidad_carga_datos: 'Carga de datos',
    reembolsos_reporte: 'Liquidaciones reembolsos',
    global_search_placeholder: 'Búsqueda global',
    global_search: {
      title: 'Búsqueda global',
      mobile_placeholder: 'Busca en toda tu plataforma',
      modal_placeholder: 'Buscar por producto, pedido...',
      result: 'resultado',
      results: 'resultados',
      loading: 'Buscando...',
      no_results: 'No se encontraron resultados',
      no_results_title: 'Oops... No hemos encontrado nada.',
      no_results_description: 'Prueba de nuevo usando otros términos de búsqueda',
      no_product: 'Sin producto',
      no_status: 'Sin estado',
      navigate: 'Navegar',
      close: 'Cerrar',
      open: 'Abrir',
      go: 'Ir',
      category: {
        product: 'Producto',
        cart: 'En carrito',
        entry: 'Entradas',
        order: 'Pedido',
        merchandise: 'Mercancía',
        location: 'Ubicación',
        preparation: 'Preparación',
        returned_reception: 'Recepción devuelta',
      },
    },
    cod_payments: 'Pagos COD',
    cod_payouts: 'Liquidaciones',
    cod_payout_items: 'Items de Liquidaciones',
    cod_courier_files: 'Archivos Courier',
    cod_mismatches: 'Reporte de Reembolsos',
    packing: 'Packing',
    gestion_popups: 'Gestión de Popups',
    switchTeam: {
      success: {
        title: 'Empresa cambiada',
        description: 'Se ha cambiado de empresa exitosamente',
      },
      error: {
        title: 'Error al cambiar de empresa',
        unexpected: 'Error inesperado al cambiar de empresa. Inténtalo de nuevo.',
      },
    },
  },
  table: {
    activate: 'Activar',
    deactivate: 'Desactivar',
  },
};

export default navigationEs;
